import React from 'react';
import styled from 'styled-components';
import Toolbar from 'spark-ui/ui-kitchen/utensils/SplitToolbar';

/**
 Grid Plate Layout
 ----------------------------------
 | Toolbar(left)    Toolbar(right)|
 |--------------------------------|
 |                                |
 |                                |
 |         Grid Content           |
 |                                |
 |________________________________|
 */

const LayoutRoot = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	gap: 16px;
`;

const Layout = ({ children }) => <LayoutRoot className="grid-layout">{children}</LayoutRoot>;

//Right now, there's no extra styles that need to be applied,
//but keeping the wrapper for encapsulation.
const Content = ({ children }) => <div className="grid-layout-content">{children}</div>;

const gridPlate = {
    Layout,
    Toolbar,
    Content
};
export default gridPlate;
